import { render, staticRenderFns } from "./yokisenuError.vue?vue&type=template&id=615c1816&scoped=true&"
import script from "./yokisenuError.vue?vue&type=script&lang=js&"
export * from "./yokisenuError.vue?vue&type=script&lang=js&"
import style0 from "./yokisenuError.vue?vue&type=style&index=0&id=615c1816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c1816",
  null
  
)

export default component.exports